export var cookiebotLoaded = function cookiebotLoaded(state) {
  return state.cookiebotLoaded;
};
export var shouldShowCookieBanner = function shouldShowCookieBanner(state) {
  return !state.cookiebotFailed;
};
export var safeCookiebotMethod = function safeCookiebotMethod() {
  return function (methodName) {
    try {
      if (window.Cookiebot && typeof window.Cookiebot[methodName] === 'function') {
        var _window$Cookiebot;
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_window$Cookiebot = window.Cookiebot)[methodName].apply(_window$Cookiebot, args);
        return true;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("Failed to call Cookiebot.".concat(methodName, ":"), error);
    }
    return false;
  };
};